var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class AuthSessionBridge {
  constructor(adapter) {
    this.adapter = adapter;
    __publicField(this, "peers", /* @__PURE__ */ new Set());
    __publicField(this, "revision", 0);
    __publicField(this, "applying", false);
    __publicField(this, "initialized", false);
    __publicField(this, "resolveLocalReady");
    __publicField(this, "localReady", new Promise((resolve) => {
      this.resolveLocalReady = resolve;
    }));
    __publicField(this, "incoming", Promise.resolve());
  }
  /** Call for Firebase's initial restored session and every subsequent change. */
  authChanged() {
    if (!this.initialized) {
      this.initialized = true;
      this.resolveLocalReady();
    } else if (!this.applying) {
      this.revision++;
      for (const port of this.peers) void this.send(port, false);
    }
  }
  connect(port, initiate) {
    this.peers.add(port);
    let settled = false;
    let finish;
    const ready = new Promise((resolve) => {
      finish = () => {
        settled = true;
        resolve();
      };
    });
    const timeout = setTimeout(finish, 12e3);
    void ready.then(() => clearTimeout(timeout));
    port.onDisconnect.addListener(() => {
      this.peers.delete(port);
      finish();
    });
    port.onMessage.addListener((message) => {
      if ((message == null ? void 0 : message.type) !== "lsComAuth" || message.version !== 2 || typeof message.initial !== "boolean")
        return;
      if (!message.error && (message.uid !== void 0 || message.token !== void 0) && (typeof message.uid !== "string" || !message.uid || typeof message.token !== "string" || !message.token))
        return;
      this.incoming = this.incoming.then(async () => {
        await this.localReady;
        if (!this.peers.has(port) || message.error) return;
        const user = this.adapter.getUser();
        if (message.initial && !message.uid) {
          if (user) await this.send(port, false);
          return;
        }
        if ((user == null ? void 0 : user.uid) === message.uid) return;
        this.revision++;
        this.applying = true;
        try {
          if (message.token) await this.adapter.signIn(message.token);
          else await this.adapter.signOut();
        } finally {
          this.applying = false;
        }
        for (const peer of this.peers)
          if (peer !== port) void this.send(peer, false);
      }).catch((error) => this.adapter.onError(error)).finally(() => {
        if (!settled) finish();
      });
    });
    if (initiate)
      void this.localReady.then(() => this.send(port, true)).finally(finish);
    return ready;
  }
  async send(port, initial) {
    const revision = this.revision;
    const user = this.adapter.getUser();
    try {
      const token = user ? await this.adapter.createToken(await user.getIdToken()) : void 0;
      if (!this.peers.has(port) || revision !== this.revision || user !== this.adapter.getUser())
        return;
      port.postMessage({
        type: "lsComAuth",
        version: 2,
        initial,
        uid: user == null ? void 0 : user.uid,
        token
      });
    } catch (error) {
      this.adapter.onError(error);
      if (initial && this.peers.has(port)) {
        try {
          port.postMessage({
            type: "lsComAuth",
            version: 2,
            initial,
            error: true
          });
        } catch (e) {
        }
      }
    }
  }
}
function isAuthSite(url, development) {
  try {
    const origin = new URL(url).origin;
    return [
      "https://www.lipsurf.com",
      "https://lipsurf.com",
      ...development ? ["http://devhost:8082", "http://localhost:8082"] : []
    ].includes(origin);
  } catch (e) {
    return false;
  }
}
export {
  AuthSessionBridge,
  isAuthSite
};
